import { render, staticRenderFns } from "./GSTCopyActivity.vue?vue&type=template&id=21c14c27&scoped=true&"
import script from "./GSTCopyActivity.vue?vue&type=script&lang=js&"
export * from "./GSTCopyActivity.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=21c14c27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c14c27",
  null
  
)

export default component.exports